import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface SimpleAdvancedToggleProps {
  isSimple: boolean;
  onToggle: (isSimple: boolean) => void;
}

/**
 * Custom Simple/Advanced toggle component for Research Parameters
 * Adapted from Image Generator toggle with purple theme
 * Replaces the "Research Parameters" header and acts as section control
 */
export const SimpleAdvancedToggle: React.FC<SimpleAdvancedToggleProps> = ({
  isSimple,
  onToggle
}) => {
  return (
    <div className="w-full relative rounded-full bg-gray-50/50 dark:bg-gray-800/50 p-0.5 flex text-xs shadow-sm border border-gray-200/30 dark:border-gray-700/30">
      {/* Animated background slider */}
      <motion.div 
        className="absolute h-full top-0 rounded-full bg-purple-500 dark:bg-purple-500 shadow-sm"
        initial={false}
        animate={{ 
          width: '50%', 
          transform: `translateX(${isSimple ? '0%' : '100%'})`,
        }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        style={{ 
          left: 0,
          top: '1px',
          height: 'calc(100% - 2px)',
        }}
      />
      
      {/* Simple Button */}
      <button
        type="button"
        onClick={() => onToggle(true)}
        className={cn(
          "relative z-10 flex-1 py-1.5 px-4 rounded-full text-xs font-medium transition-all duration-300 flex items-center justify-center",
          isSimple 
            ? "text-white dark:text-white" 
            : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
        )}
      >
        Simple
      </button>
      
      {/* Advanced Button */}
      <button
        type="button"
        onClick={() => onToggle(false)}
        className={cn(
          "relative z-10 flex-1 py-1.5 px-4 rounded-full text-xs font-medium transition-all duration-300 flex items-center justify-center",
          !isSimple 
            ? "text-white dark:text-white" 
            : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
        )}
      >
        Advanced
      </button>
    </div>
  );
}; 